import React, { useState, useRef } from "react";
import { Container, Row, Col, Card, Table, Form, Button, Alert, Navbar, Nav } from "react-bootstrap";
import image1 from "../../img/otogas.jpg";
import image2 from "../../img/oto_1.jpg";
const Benefits = () => {
    // Refs for scrolling to sections
    const benefitsRef = useRef(null);
    const refillRef = useRef(null);
    const convertRef = useRef(null);
    const consumptionRef = useRef(null);

    // Scroll to section function
    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    };

    // LPG Savings Calculator States
    const [inputType, setInputType] = useState("money");
    const [amount, setAmount] = useState("");
    const [distance, setDistance] = useState("");
    const [fuelLitres, setFuelLitres] = useState("");
    const [fuelPrice, setFuelPrice] = useState(175);
    const [lpgPrice, setLpgPrice] = useState(115);
    const [efficiency, setEfficiency] = useState(12);
    const [savings, setSavings] = useState(null);

    // LPG Conversion Cost Calculator States
    const [carType, setCarType] = useState("private");
    const [tankSize, setTankSize] = useState(60);
    const [conversionCost, setConversionCost] = useState(null);


    const [registration, setRegistration] = useState("");
    const [history, setHistory] = useState([]);
    const [showTable, setShowTable] = useState(false);

    const sampleHistory = [
        { date: "2024-02-10", station: "Otogas Northern Bypass", nozzle: "3", dispenser: "2", quantity: "20", amount: "2,400", payment: "MPesa" },
        { date: "2024-01-25", station: "Otogas Kayole", nozzle: "1", dispenser: "4", quantity: "15", amount: "1,800", payment: "Cash" },
        { date: "2024-01-10", station: "Otogas 44 (Githurai 44)", nozzle: "2", dispenser: "3", quantity: "25", amount: "3,000", payment: "Card" },
    ];


    const handleSubmit = (e) => {
        e.preventDefault();
        if (registration.trim()) {
            setHistory(sampleHistory); // Replace with actual API call
            setShowTable(true);
        }
    };

    const handleClear = () => {
        setTimeout(() => {
            setRegistration("");
            setHistory([]);
            setShowTable(false);
        }, 5000); // Small delay prevents accidental clearing while clicking inside the card
    };

    // Calculate LPG Savings
    const calculateSavings = () => {
        let fuelCost = 0,
            lpgCost = 0,
            savingsAmount = 0;
        let litresUsed = 0;

        if (inputType === "money") {
            litresUsed = amount / fuelPrice;
        } else if (inputType === "distance") {
            litresUsed = distance / efficiency;
        } else if (inputType === "fuel") {
            litresUsed = fuelLitres;
        }

        fuelCost = litresUsed * fuelPrice;
        lpgCost = litresUsed * lpgPrice;
        savingsAmount = fuelCost - lpgCost;

        setSavings({
            fuelCost: fuelCost.toFixed(2),
            lpgCost: lpgCost.toFixed(2),
            savingsAmount: savingsAmount.toFixed(2),
        });
    };

    // Calculate Conversion Cost
    const calculateConversionCost = () => {
        let baseCost = carType === "private" ? 50000 : 80000;
        let tankAdjustment = tankSize > 60 ? (tankSize - 60) * 500 : 0;
        let totalCost = baseCost + tankAdjustment;

        setConversionCost(totalCost);
    };

    return (
        <>
            {/* Navigation Bar */}
            <Navbar bg="light" expand="lg" className="mb-4 sticky-top shadow-sm border-bottom">
                <Container>
                    {/* Brand / Logo */}
                    <Navbar.Brand href="#benefits" onClick={() => scrollToSection(benefitsRef)} className="fw-bold text-primary">
                        <i className="bi bi-fire me-2"></i> Otogas
                    </Navbar.Brand>

                    {/* Navbar Toggle for Mobile */}
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    {/* Collapsible Menu */}
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">

                            <Nav.Link href="#refill" onClick={() => scrollToSection(refillRef)}>
                                <i className="bi bi-fuel-pump me-1"></i> Where to Refill
                            </Nav.Link>
                            <Nav.Link href="#convert" onClick={() => scrollToSection(convertRef)}>
                                <i className="bi bi-tools me-1"></i> Want to Convert?
                            </Nav.Link>
                            <Nav.Link href="#consumption" onClick={() => scrollToSection(consumptionRef)}>
                                <i className="bi bi-speedometer2 me-1"></i> Check My Consumption
                            </Nav.Link>
                        </Nav>



                        {/* Login Button on the Right */}
                        <Nav className="ms-auto">
                            <Nav.Link href="/login" className="btn btn-outline-primary px-4 fw-bold">
                                <i className="bi bi-box-arrow-in-right me-1"></i> Login
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>


            {/* One-Page Content */}
            <Container className="mt-4">

                
                {/* Benefits Section */}
                <div ref={benefitsRef}>
                    <Row>
                        
                        <Col lg={8} md={7}>
                        <div id="lpgCarousel" className="carousel slide mb-4" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={image1} className="d-block w-100" alt="LPG Vehicle Conversion" />
                </div>
                {/* <div className="carousel-item">
                    <img src={image2} className="d-block w-100" alt="LPG Refueling Station" />
                </div>
                <div className="carousel-item">
                    <img src="image3.jpg" className="d-block w-100" alt="Eco-Friendly LPG Benefits" />
                </div> */}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#lpgCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#lpgCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>

                        <Card className="mt-2 pt-5 shadow-sm">
    <Card.Body>
        {/* <!-- Section: Introduction --> */}
        <h3 className="text-primary mb-3">
            <i className="bi bi-fire me-2"></i> Why More Drivers Are Switching to LPG
        </h3>
        <p className="text-muted">
            With fuel prices constantly rising, many Kenyan motorists, including taxi and PSV operators,
            are embracing <b>Liquefied Petroleum Gas (LPG)</b> as a <b>cost-effective, eco-friendly, and efficient</b> alternative.
            Switching to LPG can help you <b>save money, extend engine life, and reduce harmful emissions.</b>
        </p>

        {/* <!-- Carousel for Images --> */}


        {/* <!-- Section: Key Benefits --> */}
        <div className="mt-3">
            {/* <!-- Lower Fuel Costs --> */}
            <h4 className="text-dark">
                <i className="bi bi-cash-stack me-2"></i> Drastically Lower Fuel Costs
            </h4>
            <p>
                <b>LPG is up to 50% cheaper per litre</b> compared to petrol or diesel. Many vehicle owners
                <b> report savings of up to 40%</b>, making it an excellent choice for cutting down on fuel expenses.
            </p>
            <ul className="text-muted">
                <li><i className="bi bi-check-circle-fill text-success me-2"></i> Cheaper refueling costs compared to petrol/diesel.</li>
                <li><i className="bi bi-check-circle-fill text-success me-2"></i> More predictable pricing with lower market volatility.</li>
            </ul>

            {/* <!-- Engine Longevity --> */}
            <h4 className="text-dark">
                <i className="bi bi-gear-wide-connected me-2"></i> Longer Engine Life & Reduced Maintenance
            </h4>
            <p>
                Unlike petrol and diesel, LPG burns more <b>cleanly</b>, producing <b>fewer carbon deposits</b>
                and reducing <b>engine wear</b>.
            </p>
            <ul className="text-muted">
                <li><i className="bi bi-check-circle-fill text-info me-2"></i> Lower engine wear and tear, leading to a longer vehicle lifespan.</li>
                <li><i className="bi bi-check-circle-fill text-info me-2"></i> Less frequent oil changes and reduced carbon buildup.</li>
            </ul>

            {/* <!-- Environmental Benefits --> */}
            <h4 className="text-dark">
                <i className="bi bi-globe me-2"></i> Eco-Friendly & Lower Carbon Footprint
            </h4>
            <p>
                LPG produces <b>significantly fewer emissions</b>, making it a <b>greener fuel choice</b>.
                This helps combat air pollution and contributes to a <b>cleaner environment</b>.
            </p>
            <ul className="text-muted">
                <li><i className="bi bi-check-circle-fill text-warning me-2"></i> 80% fewer nitrogen oxides than diesel vehicles.</li>
                <li><i className="bi bi-check-circle-fill text-warning me-2"></i> No harmful particulates, improving air quality.</li>
            </ul>

            {/* <!-- Government Incentives --> */}
            <h4 className="text-dark">
                <i className="bi bi-wallet me-2"></i> Tax Benefits & Government Incentives
            </h4>
            <p>
                Many governments, including Kenya, are encouraging the adoption of LPG by offering
                <b> tax reductions and incentives</b>.
            </p>
            <ul className="text-muted">
                <li><i className="bi bi-check-circle-fill text-primary me-2"></i> Reduced excise duty on LPG fuel.</li>
                <li><i className="bi bi-check-circle-fill text-primary me-2"></i> Possible rebates & subsidies for LPG vehicle conversions.</li>
            </ul>
        </div>
    </Card.Body>
</Card>





                            <Card ref={refillRef} className="mt-5 pt-5 shadow-sm">
                                <Card.Body>
                                    <div >
                                        <h2>Where to Refuel</h2>
                                        <p>Looking for a convenient place to refill your gas? We’ve got you covered! Visit any of our refill stations for fast, safe, and affordable service.</p>

                                        <h3>Our Refill Stations</h3>
                                        <ul>
                                            <li><strong>Otogas Northern Bypass</strong> – Conveniently located near Astrol Petrol Station for easy access.</li>
                                            <li><strong>Otogas Kayole</strong> – Serving Kayole and surrounding areas with reliable gas refills.</li>
                                            <li><strong>Otogas 44 (Githurai 44)</strong> – Find us near Naivas Githurai 44 for quick and efficient service.</li>
                                        </ul>

                                        <p>Whether you're at home, on the road, or running a business, you can count on us for top-quality gas and excellent customer service. Stop by today and refill with confidence!</p>
                                    </div>
                                </Card.Body>
                            </Card>


                            {/* Want to Convert Section */}
                            <Card ref={convertRef} className="mt-5 pt-5 shadow-sm">
                                <Card.Body>
                                    <div>
                                        <h2 className="mb-3">Want to Convert Your Car to LPG?</h2>
                                        <p>
                                            Looking to switch to a more cost-effective and eco-friendly fuel solution?
                                            Convert your car to run on LPG (Liquefied Petroleum Gas) and enjoy benefits such as lower fuel costs, reduced emissions, and a smoother driving experience.
                                            Fill in your details below, and our team will get in touch with you!
                                        </p>

                                        <Form className="mt-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Customer Details</strong></Form.Label>
                                                <Form.Control type="text" placeholder="Enter your full name" required />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Phone Number</strong></Form.Label>
                                                <Form.Control type="tel" placeholder="Enter your phone number" required />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Email Address</strong> (Optional)</Form.Label>
                                                <Form.Control type="email" placeholder="Enter your email address" />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Car Details</strong></Form.Label>
                                                <Form.Control type="text" placeholder="Enter car make and model (e.g., Toyota Corolla 2018)" required />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Preferred Conversion Location</strong></Form.Label>
                                                <Form.Select>
                                                    <option>Select a location</option>
                                                    <option>Otogas Northern Bypass</option>
                                                    <option>Otogas Kayole</option>
                                                    <option>Otogas 44 (Githurai 44)</option>
                                                </Form.Select>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Additional Comments</strong> (Optional)</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Any specific requests or questions?" />
                                            </Form.Group>

                                            <Button variant="primary" className="w-100" type="submit">
                                                Submit Request
                                            </Button>
                                        </Form>

                                        <p className="mt-3 text-muted">
                                            Our team will contact you within 24 hours to discuss the next steps.
                                            Join the LPG revolution today and drive smarter!
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>


                            {/* Check My Consumption Section */}
                            <Card ref={consumptionRef} className="mt-5 pt-5 shadow-sm" onMouseLeave={handleClear}>
                                <Card.Body>
                                    <div>
                                        <h2 className="mb-3">Check My Consumption</h2>
                                        <p>Track your fuel consumption history by entering your vehicle registration number below.</p>

                                        <Form className="mt-4" onSubmit={handleSubmit}>
                                            <Form.Group className="mb-3">
                                                <Form.Label><strong>Vehicle Registration</strong></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter registration number (e.g., KAB 123A)"
                                                    value={registration}
                                                    onChange={(e) => setRegistration(e.target.value)}
                                                    required
                                                />
                                            </Form.Group>

                                            <Button variant="primary" className="w-100" type="submit">
                                                Check Consumption
                                            </Button>
                                        </Form>

                                        {/* Refill History Table - Show only when there is data */}
                                        {showTable && history.length > 0 && (
                                            <div className="mt-4">
                                                <h4>Refill History</h4>
                                                <Table striped bordered hover responsive className="mt-3">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Station</th>
                                                            <th>Nozzle</th>
                                                            <th>Dispenser</th>
                                                            <th>Quantity (Liters)</th>
                                                            <th>Amount (KES)</th>
                                                            <th>Payment Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {history.map((entry, index) => (
                                                            <tr key={index}>
                                                                <td>{entry.date}</td>
                                                                <td>{entry.station}</td>
                                                                <td>{entry.nozzle}</td>
                                                                <td>{entry.dispenser}</td>
                                                                <td>{entry.quantity}</td>
                                                                <td>{entry.amount}</td>
                                                                <td>{entry.payment}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>

                        </Col>

                        {/* Right Column - Savings & Conversion Calculators */}
                        <Col lg={4} md={5}>
                            <div className="sticky-top" style={{ top: "80px" }}>
                                {/* LPG Savings Calculator */}
                                <Card className="p-3 shadow-sm mb-3">
                                    <Card.Body>
                                        <h4 className="text-success">
                                            <i className="fas fa-calculator me-2"></i> LPG Savings Calculator
                                        </h4>
                                        <p className="text-muted">Calculate savings based on Money, Distance, or Fuel used.</p>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Input Type</Form.Label>
                                            <Form.Select value={inputType} onChange={(e) => setInputType(e.target.value)}>
                                                <option value="money">Money Spent on Fuel</option>
                                                <option value="distance">Distance to Travel (km)</option>
                                                <option value="fuel">Litres of Fuel Used</option>
                                            </Form.Select>
                                        </Form.Group>

                                        {inputType === "money" && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Amount Spent on Fuel (KES)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter amount spent"
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                />
                                            </Form.Group>
                                        )}

                                        {inputType === "distance" && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Distance to Travel (km)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter distance in km"
                                                    value={distance}
                                                    onChange={(e) => setDistance(e.target.value)}
                                                />
                                            </Form.Group>
                                        )}

                                        {inputType === "fuel" && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Litres of Fuel Used</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter litres of fuel"
                                                    value={fuelLitres}
                                                    onChange={(e) => setFuelLitres(e.target.value)}
                                                />
                                            </Form.Group>
                                        )}

                                        <Form.Group className="mb-3">
                                            <Form.Label>Fuel & LPG Efficiency (km per litre)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Enter efficiency"
                                                value={efficiency}
                                                onChange={(e) => setEfficiency(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Button variant="primary" className="w-100" onClick={calculateSavings}>
                                            Calculate Savings
                                        </Button>

                                        {savings && (
                                            <Alert variant="info" className="mt-3 w-100 p-3" style={{ wordWrap: "break-word", overflow: "hidden" }}>
                                                <h5>Savings Summary</h5>
                                                <p><b>Fuel Cost:</b> KES {savings.fuelCost}</p>
                                                <p><b>LPG Cost:</b> KES {savings.lpgCost}</p>
                                                <p><b>Total Savings:</b> KES {savings.savingsAmount}</p>
                                            </Alert>
                                        )}
                                    </Card.Body>
                                </Card>

                                {/* Conversion Cost Calculator */}
                                <Card className="p-3 shadow-sm">
                                    <Card.Body>
                                        <h4 className="text-info">
                                            <i className="fas fa-tools me-2"></i> LPG Conversion Cost Calculator
                                        </h4>
                                        <p className="text-muted">Estimate the cost of converting your vehicle to LPG.</p>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Vehicle Type</Form.Label>
                                            <Form.Select value={carType} onChange={(e) => setCarType(e.target.value)}>
                                                <option value="private">Private Car</option>
                                                <option value="psv">PSV (Taxi, Matatu)</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Tank Size (Litres)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Enter tank size"
                                                value={tankSize}
                                                onChange={(e) => setTankSize(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Button variant="secondary" className="w-100" onClick={calculateConversionCost}>
                                            Calculate Conversion Cost
                                        </Button>

                                        {conversionCost && (
                                            <Alert variant="secondary" className="mt-3 w-100 p-3" style={{ wordWrap: "break-word", overflow: "hidden" }}>
                                                <h5>Estimated Conversion Cost</h5>
                                                <p><b>Total Cost:</b> KES {conversionCost}</p>
                                            </Alert>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Where to Refill Section */}

            </Container>
        </>
    );
};

export default Benefits;